import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getBairunUserGroupAuditList, userGroupAuditCheck, getCarGroupList } from '@/api/bairun/userGroup'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'UserGroupAudit',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      auditType: '1',
      // 1=待审核 2=审核通过 3=审核不通过
      stationOptions: [],
      carGroupOptions: [],
      type: '',
      dialogVisible: false,
      dialogTitle: '',
      formData: {},
      dateRangeValueArr: [],
      auditingTable: {
        total: 0,
        tableData: [],
        searchInfo: {
          page: 1,
          pageSize: 10,
          auditStatus: 1,
          // 待审核
          stationId: ''
        }
      },
      auditedTable: {
        total: 0,
        tableData: [],
        searchInfo: {
          page: 1,
          pageSize: 10,
          auditStatus: 2,
          // 审核通过
          stationId: '',
          timeStart: '',
          timeEnd: ''
        }
      },
      unpassDateRangeValueArr: [],
      auditedUnpassTable: {
        total: 0,
        tableData: [],
        searchInfo: {
          page: 1,
          pageSize: 10,
          auditStatus: 3,
          // 审核不通过
          stationId: '',
          timeStart: '',
          timeEnd: ''
        }
      },
      rules: {
        auditStatus: [{
          required: true,
          message: '请选择审批结果',
          trigger: 'blur'
        }],
        auditRemark: [{
          required: true,
          message: '请输入审批意见',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions, carGroupOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _context3.next = 6;
                return getCarGroupList({
                  donNotShowLoading: true
                });

              case 6:
                carGroupOptions = _context3.sent;
                _this3.carGroupOptions = carGroupOptions.data.platformInfoList;

                _this3.onTabClick();

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 待审核
    onAuditingSubmit: function onAuditingSubmit() {
      this.auditingTable.searchInfo.page = 1;
      this.auditingTable.searchInfo.pageSize = 10;
      this.getAudtingTable();
    },
    // 待审核
    onAuditingReset: function onAuditingReset() {
      this.auditingTable.searchInfo = {
        page: 1,
        pageSize: 10,
        auditStatus: 1,
        // 待审核
        stationId: ''
      };
      this.onAuditingSubmit();
    },
    // 待审核
    handleAuditingSizeChange: function handleAuditingSizeChange(val) {
      this.auditingTable.searchInfo.pageSize = val;
      this.getAudtingTable();
    },
    handleAuditingCurrentChange: function handleAuditingCurrentChange(val) {
      this.auditingTable.searchInfo.page = val;
      this.getAudtingTable();
    },
    // 待审核
    getAudtingTable: function getAudtingTable() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4; // eslint-disable-next-line eqeqeq

                if (that.auditingTable.searchInfo.stationId != '') {
                  that.auditingTable.searchInfo.stationId = parseInt(that.auditingTable.searchInfo.stationId);
                }

                debugger;
                _context4.next = 5;
                return getBairunUserGroupAuditList(that.filterMap(that.auditingTable.searchInfo));

              case 5:
                res = _context4.sent;
                that.auditingTable.tableData = res.data.list;
                that.auditingTable.total = res.data.total;

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 审核通过
    onAuditedSubmit: function onAuditedSubmit() {
      this.auditedTable.searchInfo.page = 1;
      this.auditedTable.searchInfo.pageSize = 10;
      this.getAudtedTable();
    },
    // 审核通过
    onAuditedReset: function onAuditedReset() {
      this.dateRangeValueArr = [];
      this.auditedTable.searchInfo = {
        page: 1,
        pageSize: 10,
        auditStatus: 2,
        // 审核通过
        stationId: '',
        timeStart: '',
        timeEnd: ''
      };
      this.onAuditedSubmit();
    },
    // 审核通过
    handleAuditedSizeChange: function handleAuditedSizeChange(val) {
      this.auditedTable.searchInfo.pageSize = val;
      this.getAudtedTable();
    },
    // 审核通过
    handleAuditedCurrentChange: function handleAuditedCurrentChange(val) {
      this.auditedTable.searchInfo.page = val;
      this.getAudtedTable();
    },
    // 审核通过
    getAudtedTable: function getAudtedTable() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                debugger; // eslint-disable-next-line eqeqeq

                if (that.dateRangeValueArr.length == 2) {
                  console.log(that.dateRangeValueArr);
                  that.auditedTable.searchInfo.timeStart = that.dateRangeValueArr[0] + ' 00:00:00';
                  that.auditedTable.searchInfo.timeEnd = that.dateRangeValueArr[1] + ' 23:59:59';
                } // eslint-disable-next-line eqeqeq


                if (that.auditedTable.searchInfo.stationId != '') {
                  that.auditedTable.searchInfo.stationId = parseInt(that.auditedTable.searchInfo.stationId);
                }

                debugger;
                _context5.next = 7;
                return getBairunUserGroupAuditList(that.filterMap(that.auditedTable.searchInfo));

              case 7:
                res = _context5.sent;
                that.auditedTable.tableData = res.data.list;
                that.auditedTable.total = res.data.total;

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 审核不通过
    onAuditedUnpassSubmit: function onAuditedUnpassSubmit() {
      this.auditedUnpassTable.searchInfo.page = 1;
      this.auditedUnpassTable.searchInfo.pageSize = 10;
      this.getAudtedUnpassTable();
    },
    // 审核不通过
    onAuditedUnpassReset: function onAuditedUnpassReset() {
      this.unpassDateRangeValueArr = [];
      this.auditedUnpassTable.searchInfo = {
        page: 1,
        pageSize: 10,
        auditStatus: 3,
        // 审核不通过
        stationId: '',
        timeStart: '',
        timeEnd: ''
      };
      this.onAuditedUnpassSubmit();
    },
    // 审核不通过
    handleAuditedUnpassSizeChange: function handleAuditedUnpassSizeChange(val) {
      this.auditedUnpassTable.searchInfo.pageSize = val;
      this.getAudtedUnpassTable();
    },
    // 审核不通过
    handleAuditedUnpassCurrentChange: function handleAuditedUnpassCurrentChange(val) {
      this.auditedUnpassTable.searchInfo.page = val;
      this.getAudtedUnpassTable();
    },
    // 审核不通过
    getAudtedUnpassTable: function getAudtedUnpassTable() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6; // eslint-disable-next-line eqeqeq

                if (that.unpassDateRangeValueArr.length == 2) {
                  console.log(that.unpassDateRangeValueArr);
                  that.auditedUnpassTable.searchInfo.timeStart = that.unpassDateRangeValueArr[0] + ' 00:00:00';
                  that.auditedUnpassTable.searchInfo.timeEnd = that.unpassDateRangeValueArr[1] + ' 23:59:59';
                } // eslint-disable-next-line eqeqeq


                if (that.auditedUnpassTable.searchInfo.stationId != '') {
                  that.auditedUnpassTable.searchInfo.stationId = parseInt(that.auditedUnpassTable.searchInfo.stationId);
                }

                _context6.next = 5;
                return getBairunUserGroupAuditList(that.filterMap(that.auditedUnpassTable.searchInfo));

              case 5:
                res = _context6.sent;
                that.auditedUnpassTable.tableData = res.data.list;
                that.auditedUnpassTable.total = res.data.total;

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // tab切换事件
    onTabClick: function onTabClick() {
      var that = this; // eslint-disable-next-line eqeqeq

      if (that.auditType == '1') {
        that.getAudtingTable();
      } // eslint-disable-next-line eqeqeq


      if (that.auditType == '2') {
        that.getAudtedTable();
      } // eslint-disable-next-line eqeqeq


      if (that.auditType == '3') {
        that.getAudtedUnpassTable();
      }
    },
    // 审批
    onAudit: function onAudit(row) {
      var that = this;
      that.dialogVisible = true;
      that.dialogTitle = '审批操作';
      that.type = 'audit';
      that.formData = row;
      that.formData.auditStatus = '';
      that.formData.stationName = that.$options.filters.getStationName(that.formData.stationId);
      that.formData.oilCodeName = '#' + that.formData.oilCode;
    },
    // 查看
    onView: function onView(row) {
      var that = this;
      that.dialogVisible = true;
      that.dialogTitle = '查看操作';
      that.type = 'view';
      that.formData = row;
      that.formData.stationName = that.$options.filters.getStationName(that.formData.stationId);
      that.formData.oilCodeName = '#' + that.formData.oilCode;
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.dialogTitle = '';
      this.type = '';
      this.formData = {};
      this.onTabClick();
    },
    enterDialog: function enterDialog() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this7;

                if (that.type === 'audit') {
                  that.$refs['formData'].validate(function (valid) {
                    // eslint-disable-next-line no-empty
                    if (valid) {
                      var param = {
                        ID: that.formData.ID,
                        auditStatus: parseInt(that.formData.auditStatus),
                        auditRemark: that.formData.auditRemark
                      };
                      userGroupAuditCheck(param).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.closeDialog();
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 过滤map中为空的key
    filterMap: function filterMap(map) {
      var resMap = {};

      for (var key in map) {
        // eslint-disable-next-line eqeqeq
        if (map[key] !== '') {
          resMap[key] = map[key];
        }
      }

      debugger;
      return resMap;
    }
  }
};